import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const VisitKioskIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="23.42" 
      height="23.985" 
      viewBox="0 0 23.42 23.985"
      style={{ enableBackground: "new 0 0 48 46;" }}
      xmlSpace="preserve"
      {...props}
    >
      <g id="DataExchange_Transfer" transform="translate(0.5)">
        <path id="Path_384" data-name="Path 384" d="M13.556,27.642H1.043V23.471H7.3V22.428H1.043V18.257H7.3V17.214H1.043V13.043H7.3V12H1.043A1.046,1.046,0,0,0,0,13.043v14.6a1.046,1.046,0,0,0,1.043,1.043H13.556A1.046,1.046,0,0,0,14.6,27.642v-3.65H13.556Z" transform="translate(0 -5.743)" fill="#007bc3" stroke="#007bc3" stroke-width="1"/>
        <rect id="Rectangle_1195" data-name="Rectangle 1195" width="0.911" height="0.911" transform="translate(1.865 9.101)" fill="#fff"/>
        <rect id="Rectangle_1196" data-name="Rectangle 1196" width="0.911" height="0.911" transform="translate(1.865 14.57)" fill="#fff"/>
        <rect id="Rectangle_1197" data-name="Rectangle 1197" width="0.911" height="0.911" transform="translate(1.865 20.039)" fill="#fff"/>
        <path id="Path_385" data-name="Path 385" d="M28.556,2H16.043A1.046,1.046,0,0,0,15,3.043v14.6a1.046,1.046,0,0,0,1.043,1.043H28.556A1.046,1.046,0,0,0,29.6,17.642V3.043A1.046,1.046,0,0,0,28.556,2Zm0,15.642H16.043V13.471H28.556Zm0-5.214H16.043V8.257H28.556Zm0-5.214H16.043V3.043H28.556Z" transform="translate(-7.179 -0.957)" fill="#007bc3" stroke="#007bc3" stroke-width="1"/>
        <rect id="Rectangle_1198" data-name="Rectangle 1198" width="0.911" height="0.911" transform="translate(10.069 3.632)" fill="#007bc3"/>
        <rect id="Rectangle_1199" data-name="Rectangle 1199" width="0.911" height="0.911" transform="translate(10.069 9.101)" fill="#007bc3"/>
        <rect id="Rectangle_1200" data-name="Rectangle 1200" width="0.911" height="0.911" transform="translate(10.069 13.658)" fill="#007bc3"/>
        <path id="Path_386" data-name="Path 386" d="M6.158,3.493l-.73-.73-.678.678V2.607A1.536,1.536,0,0,1,6.315,1.043H7.358V0H6.315A2.582,2.582,0,0,0,3.708,2.607v.834L3.03,2.763l-.73.73L4.229,5.423Z" transform="translate(-1.101)" fill="#007bc3"/>
        <path id="Path_387" data-name="Path 387" d="M32.2,37.529l.73.73.678-.678v.834a1.536,1.536,0,0,1-1.564,1.564H31v1.043h1.043a2.582,2.582,0,0,0,2.607-2.607v-.834l.678.678.73-.73L34.128,35.6Z" transform="translate(-14.836 -17.038)" fill="#007bc3"/>
      </g>
    </StyledSVGIcon>
  );
};
